export const iconFontAwesomeCommunicationSquareRss = (
	<i className="fa-solid fa-square-rss"></i>
);
